import { SvgIcon, SvgIconProps } from '@mui/material';

export function NestedFilterAltRounded({
  color = 'primary',
  fontSize,
}: SvgIconProps) {
  return (
    <SvgIcon color={color} fontSize={fontSize}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.08 3.92086C3.08 3.62263 2.83823 3.38086 2.54 3.38086C2.24177 3.38086 2 3.62263 2 3.92086V13.8209V14.3609H2.54H9.73998C10.0382 14.3609 10.28 14.1191 10.28 13.8209C10.28 13.5226 10.0382 13.2809 9.73998 13.2809H3.08V3.92086ZM13.3054 14.7209C13.3054 14.7209 10.2184 10.7519 8.13043 8.06986C7.67143 7.47586 8.09443 6.62086 8.84142 6.62086H21.3604C22.1164 6.62086 22.5394 7.47586 22.0804 8.06986C19.9924 10.7519 16.9054 14.7209 16.9054 14.7209V19.2209C16.9054 20.2109 16.0954 21.0209 15.1054 21.0209C14.1154 21.0209 13.3054 20.2109 13.3054 19.2209V14.7209Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
